<template>
    <b-container fluid style="padding-left: 40px; padding-right: 40px; height: 100%;">
        <parallax :fixed="true" style="min-height: 15vh; max-height: 100vh; height: auto !important;">
            <img src="../assets/parallax_trgovci_p.jpg" alt="" style="filter: brightness(60%);">
        </parallax>

        <div>
            <h1 style="color: white;">{{ $t('common.registration') }}</h1>
            <h4 style="color: white;">{{ $t('common.registration_2') }}</h4>
        </div>

        <b-card>
            <b-card-body>
                <b-row align-h="center" >
                    <b-col style="background-color: #fff;">
                        <h3 style="padding-left: 40px;">{{ $t('registration-confirmed.title') }}</h3>
                    </b-col>
                </b-row>
                <b-row align-h="center">
                    <b-col align-v="stretch">
                        <h4>
                            {{ $t('registration-confirmed.sub-title_1') }}
                            <b>{{merchant.email}}</b>
                            {{ $t('registration-confirmed.sub-title_2') }}
                        </h4>
                    </b-col>
                </b-row>
            </b-card-body>
        </b-card>
    </b-container>
</template>

<script>
import Parallax from 'vue-parallaxy'

export default {
    name: "RegistrationConfirmed",
    components: { Parallax },
    computed: {
        merchant() {
            return this.$store.getters.getMerchant;
        }
    },
}
</script>

<style scoped>

</style>